import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { Input, Select, Spin } from "antd";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { FilterDropdownProps } from "antd/es/table/interface";
import CommonSelect from "../../../../../core/common/commonSelect";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import Table from "../../../../../core/common/dataTable/index";
type Permission = { id: number; name: string };
type Admin = {
  teacher_id: number,
  employee_id: string,
  employee_code: string,
  full_name: string,
  department_name: string,
  is_active: boolean,
  has_ticket: boolean,
};

type Department = {
  department_id: number,
  name: string,
}

type Designation = {
  designation_id: number,
  name: string,
}

type Branch = {
  branch_id: number,
  name: string,
  label: string,
}

type Class = {
  class_name_id: number,
  name: string,
  label: string,
}

type Service_division = {
  id: number,
  name: string,
}

export type Option = {
  value: string;
  label: string;
};


const getStoredServiceDivision = (): Option | null => {
  const stored = localStorage.getItem('employeeSelectedServiceDivision');
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

const ScoreEmployeeDailed = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramId = searchParams.get("id");

  if (paramId !== null && !isNaN(Number(paramId))) {
    localStorage.setItem("id", paramId);
  }

  const id = Number(localStorage.getItem("id"));
  const s1 = Number(searchParams.get("s1"));
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [playingAudio, setPlayingAudio] = useState<string | null>(null);
  const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
  const [showCalendar1, setShowCalendar1] = useState(false);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [designations, setDesignations] = useState<Designation[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<number>(
    Number(localStorage.getItem('selectedBranch')) || 0
  );
  const [selectedDepartment, setSelectedDepartment] = useState<number>(
    Number(localStorage.getItem('selectedDepartment')) || 0
  );
  const [selectedDesignation, setSelectedDesignation] = useState<number>(
    Number(localStorage.getItem('selectedDesignation')) || 0
  );

  const [selectedClass, setSelectedClass] = useState<number>(
    Number(localStorage.getItem('selectedClass')) || 0
  );

  const handleClearDepartment = () => setSelectedDepartment(0);
  const handleClearDesignation = () => setSelectedDesignation(0);
  const handleClearClass = () => setSelectedClass(0);
  const [nameSearch, setNameSearch] = useState("");
  const [classTeacherSearch, setClassTeacherSearch] = useState("");
  // const [selectedBranch, setSelectedBranch] = useState<number>(0);
  const handleClearBranch = () => setSelectedBranch(0);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [classes, setClasses] = useState<Class[]>([]);
  const [serviceDivisionDropdown, setServiceDivisionDropdown] = useState<Service_division[]>([]);
  const [selectedServiceDivision, setSelectedServiceDivision] = useState<Option | null>(
    getStoredServiceDivision()
  );
  // const [startDate, setStartDate] = useState<string | null>(null);
  // const [endDate, setEndDate] = useState<string | null>(null);

  //   const [dateRange, setDateRange] = useState([
  //     {
  //       startDate: initialStartDate
  //         ? new Date(initialStartDate)
  //         : new Date(new Date().setHours(0, 0, 0, 0)),
  //       endDate: initialEndDate
  //         ? new Date(initialEndDate)
  //         : new Date(new Date().setHours(0, 0, 0, 0)),
  //       key: "selection",
  //     },
  //   ]);

  //   const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  //   const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

  useEffect(() => {
    if (selectedServiceDivision) {
      // Stringify the object before storing
      localStorage.setItem('employeeSelectedServiceDivision', JSON.stringify(selectedServiceDivision));
    }
    // else {
    //     localStorage.removeItem('dailedEmployeeSelectedServiceDivision');
    // }
  }, [selectedServiceDivision]);

  useEffect(() => {
    localStorage.setItem('selectedBranch', selectedBranch.toString());
  }, [selectedBranch]);

  useEffect(() => {
    localStorage.setItem('selectedDepartment', selectedDepartment.toString());
  }, [selectedDepartment]);

  useEffect(() => {
    localStorage.setItem('selectedDesignation', selectedDesignation.toString());
  }, [selectedDesignation]);

  useEffect(() => {
    localStorage.setItem('selectedClass', selectedClass.toString());
  }, [selectedClass]);

  useEffect(() => {
    localStorage.setItem('currentPage1', currentPage.toString());
  }, [currentPage]);

  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [totalPages, currentPage]);


  const handlePlayPause = (id: string) => {
    const currentAudio = audioRefs.current[id];

    if (currentAudio) {
      if (playingAudio === id) {
        currentAudio.pause();
        setPlayingAudio(null);
      } else {
        if (playingAudio !== null) {
          const previousAudio = audioRefs.current[playingAudio];
          if (previousAudio) {
            previousAudio.pause();
          }
        }
        currentAudio
          .play()
          .then(() => setPlayingAudio(id))
          .catch((error) => {
            console.error("Error playing audio:", error);
            setPlayingAudio(null);
          });
      }
    }
  };



  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() => {
    if (!checkPermission("can_view_score_dailed_employees", "teacher")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchServiceDivisions();
      fetchData(
        id,
        currentPage,
        pageSize,
        searchText,
        selectedDepartment,
        selectedDesignation,
        nameSearch,
        selectedBranch,
        classTeacherSearch,
        selectedClass,
        selectedServiceDivision?.value
      );

      fetchDepartments();
      fetchDesignations();
      fetchBranches();
      fetchClasses();

    }
  }, [userPermissions]);

  // Main data fetch
  useEffect(() => {
    fetchData(
      id,
      currentPage,
      pageSize,
      searchText,
      selectedDepartment,
      selectedDesignation,
      nameSearch,
      selectedBranch,
      classTeacherSearch,
      selectedClass,
      selectedServiceDivision?.value
    );
  }, [id, currentPage, pageSize, searchText, selectedDepartment, selectedDesignation, nameSearch, selectedBranch, classTeacherSearch, selectedClass]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchDepartments = async () => {
    try {
      const response = await fetch(
        `${webApi}/employees/teacher_departments_dropdown/`,
        options
      );
      const data = await response.json();
      setDepartments(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchServiceDivisions = async () => {
    try {
      const response = await fetch(
        `${webApi}/employees/teacher_service_division_dropdown_based_on_user_with_all/`,
        options
      );
      const data = await response.json();
      setServiceDivisionDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchBranches = async () => {
    try {
      const response = await fetch(
        `${webApi}/employees/employee_branches_dropdown/`,
        options
      );
      const data = await response.json();
      setBranches(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchClasses = async () => {
    try {
      const response = await fetch(
        `${webApi}/branches/branches_class_name_dropdown/`,
        options
      );
      const data = await response.json();
      setClasses(data.results);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchDesignations = async () => {
    try {
      const response = await fetch(
        `${webApi}/employees/teacher_designations_dropdown/`,
        options
      );
      const data = await response.json();
      setDesignations(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  }

  const fetchGroupsData = async (
    id: number,
    page: number,
    pageSize: number,
    searchText: string,
    department: number,
    designation: number,
    name: string,
    branch: number,
    classTeacher: string,
    teacherForClass: number,
    serviceDivision: any,
  ) => {
    let apiUrl = `${webApi}/score/score_dialed_teacher/?page=${page}&page_size=${pageSize}&branch=${id}`;
    if (searchText) apiUrl += `&search=${searchText}`;
    if (department) apiUrl += `&department=${department}`;
    if (designation) apiUrl += `&designation=${designation}`;
    if (name) apiUrl += `&name=${name}`;
    if (branch) apiUrl += `&branch=${branch}`;
    if (classTeacher) apiUrl += `&class_teacher_section_name=${classTeacher}`
    if (teacherForClass) apiUrl += `&class_teacher_of_class=${teacherForClass}`
    if (serviceDivision) apiUrl += `&service_division_ids=${serviceDivision}`
    const response = await fetch(
      apiUrl,
      options
    );
    if (!response.ok) {
      if (response.status === 404) {
        return await response.json();
      }
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };


  const fetchData = async (
    id: number,
    page: number,
    pageSize: number,
    searchText: string,
    department: number,
    designation: number,
    name: string,
    branch: number,
    classTeacher: string,
    teacherForClass: number,
    serviceDivision: any,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(id, page, pageSize, searchText, department, designation, name, branch, classTeacher, teacherForClass, serviceDivision),
      ]);
      setSelectedServiceDivision(
        groupsData.service_division
          ? {
            value: groupsData.service_division.id.toString(),
            label: groupsData.service_division.name,
          }
          : null
      );
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setTotalCount(groupsData.total_count);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    console.log(admin);
  }, [admin])

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  const handleServiceDivisionChange = async (selected: Option | null) => {
    const serviceDivision = serviceDivisionDropdown.find(
      (c) => c.id === parseInt(selected?.value || "")
    );

    const newServiceDivisionValue = serviceDivision ? serviceDivision.id.toString() : null;

    // Update state
    setSelectedServiceDivision(
      serviceDivision
        ? {
          value: serviceDivision.id.toString(),
          label: serviceDivision.name,
        }
        : null
    );
    fetchData(
      id,
      1,
      pageSize,
      searchText,
      selectedDepartment,
      selectedDesignation,
      nameSearch,
      selectedBranch,
      classTeacherSearch,
      selectedClass,
      newServiceDivisionValue // Use the value we just calculated
    );
    setCurrentPage(1);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);

  };

  const [loading, setLoading] = useState(false);

  const handleExportClick = async () => {

    window.location.href = `${webApi}/exports/export_agentwise_wizklub_call_logs/${id}?token=${jwtToken}`
  };

  const serviceDivisionOptions = serviceDivisionDropdown.map(serviceDivision => ({
    value: String(serviceDivision.id),
    label: serviceDivision.name
  }));


  const [refreshIsLoading, setRefreshIsLoading] = useState(false);
  const fetchSlotsRefresh = async (branchId: number) => {
    try {
      setRefreshIsLoading(true);

      const response = await fetch(
        `${webApi}/api/trigger_single_branch_teacher_sync/${branchId}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        console.log("Attendance sync completed:", data.message);
        console.log("Attendance updated:", data.attendance_updated);
        console.log("Slots updated:", data.slots_updated);
        // You can also trigger a refresh of your slots table here
      } else {
        console.error("Sync failed:", data.message);
      }
    } catch (error) {
      console.error("Error syncing attendance:", error);
    } finally {
      fetchData(
        id,
        currentPage,
        pageSize,
        searchText,
        selectedDepartment,
        selectedDesignation,
        nameSearch,
        selectedBranch,
        classTeacherSearch,
        selectedClass,
        selectedServiceDivision?.value
      );
      setRefreshIsLoading(false);
    }
  };



  const columns = [
    {
      title: (
        <span>
          Name
          {nameSearch && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearch})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setNameSearch("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),

      dataIndex: "full_name",
      key: "full_name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setNameSearch(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
        record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { teacher_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateEmployeeTicket}?id=${record.teacher_id}&s1=4`}
        >
          {text}
        </Link>
      ),
    },

    {
      title: (
        <span>
          Department{selectedDepartment !== 0 ? ` (${departments.find(state => state.department_id === selectedDepartment)?.name})` : ""}
          {selectedDepartment !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearDepartment}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "department_name",
      key: "department_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Department"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = departments.find((s) => s.department_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedDepartment(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {departments.map((state) => (
              <Select.Option key={state.department_id} value={state.department_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { department_name: string }) => record.department_name === value,

      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { teacher_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateEmployeeTicket}?id=${record.teacher_id}&s1=4`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Designation{selectedDesignation !== 0 ? ` (${designations.find(state => state.designation_id === selectedDesignation)?.name})` : ""}
          {selectedDesignation !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearDesignation}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "designation_name",
      key: "designation_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Designation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = designations.find((s) => s.designation_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedDesignation(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {designations.map((state) => (
              <Select.Option key={state.designation_id} value={state.designation_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { designation_name: string }) => record.designation_name === value,
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { teacher_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateEmployeeTicket}?id=${record.teacher_id}&s1=4`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: (
        <span>
          Branch{selectedBranch !== 0 ? ` (${branches.find(branch => branch.branch_id === selectedBranch)?.name})` : ""}
          {selectedBranch !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearBranch}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = branches.find((b) => b.branch_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedBranch(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {branches.map((branch) => (
              <Select.Option key={branch.branch_id} value={branch.branch_id}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { branch_name: string }) => record.branch_name === value,
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { teacher_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateEmployeeTicket}?id=${record.teacher_id}&s1=4`}
        >
          {text}
        </Link>
      ),
    },

  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">
                Score Dailed Employee Details
              </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.scoreDailedEmployeeBranches}>Branches</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Employee Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* {checkPermission("can_export_wizklub_agent_wise_call_logs", "calllog") && (
              <button className="btn btn-primary me-2" onClick={handleExportClick} disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Export"
              )}
            </button>
            )} */}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Employee List</h4>
              <div
                className="d-flex align-items-center flex-wrap"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div className="me-2" style={{
                  width: '250px',
                  marginBottom: "15px",
                  zIndex: 99,
                  position: "relative"
                }}>
                  <CommonSelect
                    className="select"
                    options={serviceDivisionOptions}
                    onChange={handleServiceDivisionChange}
                    value={selectedServiceDivision}
                    isRequired
                    styles={{
                      menu: (provided: any) => ({
                        ...provided,
                        zIndex: 9999,
                        position: "absolute"
                      }),
                      menuPortal: (provided: any) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      container: (provided: any) => ({
                        ...provided,
                        zIndex: 9999
                      })
                    }}
                  />
                </div>

                <button className="btn btn-primary" onClick={() => fetchSlotsRefresh(id)}
                >
                 {refreshIsLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<>Update Teachers</>)}
                </button>

              </div>
            </div>
            <div className="card-body p-0 py-3">
              <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["10", "20", "30", "50", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default ScoreEmployeeDailed;
